<!-- -->
<template>
  <div :class="{ baidu_search: true, mm: isMobile }">
    <div class="box">
      <div class="title-box">
        <div class="title">小红书</div>
        <div class="type">
          中国最大的生活方式内容平台，年轻人在小红书分享生活方式，探索生活灵感和了解消费信息；<br />年轻人的消费决策入口，90%的用户在小红书了解品牌/商品信息。
        </div>
      </div>
      <div class="description"></div>
      <div class="float">
        <img
          src="http://hr.pangodso.com/web_file/19aee58d94bb4a46ba6f79c02609752e.png"
          alt=""
          class="center"
        />
      </div>
    </div>
    <div class="box2">
      <div class="title-box">
        <div class="title">广告展现形式</div>
      </div>
      <div class="content">
        <div class="types">
          <div
            :class="{ type: true, active: activeType == idx }"
            @mouseenter="changeType(idx)"
            v-for="(item, idx) in allData"
            :key="item.title"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="subs" v-if="allData[activeType].children">
          <div
            :class="{ sub: true, active: activeSub == idx }"
            v-for="(child, idx) in allData[activeType].children"
            :key="child.title"
            @mouseenter="changeSub(idx)"
          >
            {{ child.title }}
          </div>
        </div>
        <div class="desc">
          <div class="desc_content" v-html="handleDesc"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
export default {
  data() {
    return {
      activeType: 0,
      allData: [
        {
          title: "开屏广告",
          children: [
            {
              title: "开屏集中曝光",
              content: `<p style="text-align: center;"><span style="color: #7e8c8d;">助力品牌 Big Day</span></p>
<table style="border-collapse: collapse; width: 100%;" border="0">
<tbody>
<tr class="mtr-flex">
<td style="width: 23.1562%;text-align: center;"><img class="mh329" style="color: #7e8c8d; text-align: center; display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/ec3c70cdb5934133aa2990a81088c217.png" alt="" width="200" height="382" /><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">有效传递品牌故事</span></td>
<td style="width: 23.1562%;text-align:center;"><img class="mh329" style="color: #7e8c8d; text-align: center; display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/912b7b3844504b80bd5e54e2913076c5.png" alt="" width="200" height="382" /><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">联合品牌节日造势</span></td>
<td style="width: 23.1562%;text-align:center;"><img class="mh329" style="display: block; text-align: center; display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/bcd2e5251f07472c885dc45ef7379671.png" alt="" width="189" height="382" /><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">新品首发大曝光</span></td>
<td style="width: 23.1562%;text-align:center;"><img class="mh329" style="color: #7e8c8d; text-align: center; display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/c67bb9f6a7cc4bb4ba557c62da15448c.png" alt="" width="200" height="382" /><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">助力品牌活动日</span></td>
</tr>
</tbody>
</table>`,
            },
            {
              title: "多落地页支持",
              content: `<p style="margin: 0px; text-align: center;"><span style="color: #7e8c8d; font-size: 12pt;">满足品牌不同推广需求</span></p>
<p style="margin: 0px; text-align: center;">&nbsp;</p>
<table style="border-collapse: collapse; width: 100%;position:relative;" border="0">
<tbody>
<tr class="mtr-flex">
<td class="marginb80" style="width: 16.6667%; text-align: center;"><span class="mspecial" style="font-size: 12pt; color: #7e8c8d;">话题页</span><img src="http://hr.pangodso.com/web_file/8a061cca6e9d46cd93cc8f1d484e08a6.png" alt="" width="120" height="243" /></td>
<td class="marginb80" style="width: 16.6667%; text-align: center;"><span class="mspecial" style="color: #7e8c8d; font-size: 12pt;">笔详页</span><img src="http://hr.pangodso.com/web_file/ed4235a2cf284ef5a51dc087f81d7041.png" alt="" width="120" height="243" /></td>
<td class="marginb80" style="width: 16.6667%; text-align: center;"><span class="mspecial" style="color: #7e8c8d; font-size: 12pt;">留咨收集页</span><img src="http://hr.pangodso.com/web_file/b1c5d7e2a3474fae96337b58a903b21a.png" alt="" width="120" height="243" /></td>
<td class="marginb80" style="width: 16.6667%; text-align: center;"><span class="mspecial" style="color: #7e8c8d; font-size: 12pt;">搜索结果页</span><img src="http://hr.pangodso.com/web_file/c69fe651742d4d1fba826a5ee89a80e0.png" alt="" width="120" height="243" /></td>
<td class="marginb80" style="width: 16.6667%; text-align: center;"><span class="mspecial" style="color: #7e8c8d; font-size: 12pt;">店铺页</span><img src="http://hr.pangodso.com/web_file/6ed14beb402b4f2aba2994e4914f27f9.png" alt="" width="120" height="243" /></td>
<td class="marginb80" style="width: 16.6667%; text-align: center;"><span class="mspecial" style="color: #7e8c8d; font-size: 12pt;">场次页</span><img src="http://hr.pangodso.com/web_file/2b1cabcc407d4d118b3070cda20dc766.png" alt="" width="120" height="243" /></td>
</tr>
<tr class="mflex">
<td class="pa pa1" style="width: 33.3333%; text-align: center;" colspan="2">
<p style="text-align: center; margin: 0px;"><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">内容传播</span></p>
<p style="text-align: center; margin: 0px;"><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">传播品牌活动，提升用户互动</span></p>
</td>
<td class="pa pa2" style="width: 33.3333%;" colspan="2">
<p style="text-align: center; margin: 0px;"><span class="mf10" style="font-size: 11pt; color: #7e8c8d;">信息收割</span></p>
<p style="text-align: center; margin: 0px;"><span class="mf10" style="font-size: 11pt; color: #7e8c8d;">加强品牌认知，积累潜在粉丝</span></p>
</td>
<td class="pa pa3" style="width: 33.3333%;" colspan="2">
<p style="text-align: center; margin: 0px;"><span class="mf10" style="font-size: 11pt; color: #7e8c8d;">消费转化</span></p>
<p style="text-align: center; margin: 0px;"><span class="mf10" style="font-size: 11pt; color: #7e8c8d;">直链站内商城，引导消费转化</span></p>
</td>
</tr>
</tbody>
</table>`,
            },
            {
              title: "产品形态及售卖方式",
              content: `<table style="border-collapse: collapse; width: 100%;" border="0">
<tbody>
<tr>
<td style="width: 48.1001%;">
<p style="margin: 0px;"><strong><span style="font-size: 12pt; color: #333;">售卖方式</span></strong></p>
<p style="margin: 0px;"><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">CPT轮播（每天可售三轮播）</span></p>
<p style="margin: 0px;">&nbsp;</p>
<p style="margin: 0px;"><strong><span style="font-size: 12pt; color: #333;">页面形态</span></strong></p>
<p style="margin: 0px;"><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">全屏/非全屏</span></p>
<p style="margin: 0px;">&nbsp;</p>
<p style="margin: 0px;"><strong><span style="font-size: 12pt; color: #333;">推广样式</span></strong></p>
<p style="margin: 0px;"><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">静态图（3s）/动态图（4s）/视频（5s）</span></p>
<p style="margin: 0px;">&nbsp;</p>
<p style="margin: 0px;"><span style="font-size: 12pt;"><strong><span style="color: #333;">落地页面</span></strong></span></p>
<p style="margin: 0px;"><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">用户留资H5/店铺页/场次页/商详页/品牌话题页/搜索结果页/笔记</span></p>
</td>
<td style="width: 48.2287%;"><img style="display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/01b74a9b07f94636a1c08448bd6c577b.png" alt="" width="400" height="342" /></td>
</tr>
<tr>
<td style="width: 48.1001%;"><span style="color: #e03e2d; font-size: 14.6667px;">*开屏每轮播间隔15分钟，单素材单日频控3次</span></td>
<td style="width: 48.2287%;">
<p><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">● 为保证效果，需提前7个工作日提交素材</span></p>
<p><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">● 开屏素材规范详见开屏素材MR</span></p>
<p><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">● 开屏设计建议详见开屏广告风格参考</span></p>
</td>
</tr>
</tbody>
</table>`,
            },
          ],
        },
        {
          title: "发现页信息流",
          content: `<p style="text-align: center;"><span style="font-size: 17px;color: #7e8c8d;">放大品牌内容传播，实现高效触达</span></p>
<p style="text-align: center;">&nbsp;</p>
<table style="border-collapse: collapse; width: 100%;" border="0">
<tbody>
<tr>
<td class="mw31" style="width: 60.6579%;"><img style="display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/4635ef92da7f45b18348b5bfa0405fc7.png" alt="" width="360" height="510" /></td>
<td class="mh" style="width: 9.20447%;">&nbsp;</td>
<td style="width: 30.1376%;">
<p><strong><span style="color: #333;font-size: 17px;">原生</span></strong></p>
<p><span style="color: #7e8c8d; font-size: 11pt;">● 发现页双列信息流展示</span></p>
<p><span style="color: #7e8c8d; font-size: 11pt;">&nbsp; &nbsp;符合用户浏览使用习惯</span></p>
<p class="mh">&nbsp;</p>
<p><strong><span style="color: #333;">保量</span></strong></p>
<p><span style="color: #7e8c8d; font-size: 11pt;">● 每天30亿次笔记曝光</span></p>
<p><span style="color: #7e8c8d; font-size: 11pt;">&nbsp; &nbsp;单人单天多次首页到访量</span></p>
<p class="mh">&nbsp;</p>
<p><strong><span style="color: #333;">精准</span></strong></p>
<p><span style="color: #7e8c8d; font-size: 11pt;">● 聚合垂直领域目标用户</span></p>
<p><span style="color: #7e8c8d; font-size: 11pt;">&nbsp; &nbsp;千人千面内容算法推荐</span></p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>`,
        },
        {
          title: "落地页模版",
          content: `<p style="text-align: center;"><span style="color: #7e8c8d; font-size: 13pt;">站内推广页HS模板「留资收集」</span></p>
<p style="text-align: center;">&nbsp;</p>
<table style="border-collapse: collapse; width: 100%;" border="0">
<tbody>
<tr class="mtr-flex">
<td style="width: 25%; text-align: center;">
<p><span style="font-size: 12pt;"><strong><span style="color: #333;">● 首 页</span></strong></span></p>
<p><strong><span style="color: #7e8c8d;"><img src="http://hr.pangodso.com/web_file/115383f1f8254481a9dfca19b9ae806a.png" alt="" width="200" height="403" /></span></strong></p>
</td>
<td style="width: 25%; text-align: center;">
<p><span style="font-size: 12pt;"><strong><span style="color: #333;">● 信息填写</span></strong></span></p>
<p><img src="http://hr.pangodso.com/web_file/783f817d9c174f6b92d4fadb8052b8d4.png" alt="" width="200" height="403" /></p>
</td>
<td style="width: 25%; text-align: center;">
<p><span style="font-size: 12pt;"><strong><span style="color: #333;">● 感谢参与</span></strong></span></p>
<p><strong><span style="color: #7e8c8d;"><img src="http://hr.pangodso.com/web_file/358e50525971451bbbbb378b58c85134.png" alt="" width="200" height="403" /></span></strong></p>
</td>
<td style="width: 25%; text-align: center;">
<p><span style="font-size: 12pt;"><strong><span style="color: #333;">● 分享好友</span></strong></span></p>
<p><img src="http://hr.pangodso.com/web_file/2e8246fb84df4a65b34d9eb7113c6852.png" alt="" width="200" height="403" /></p>
</td>
</tr>
<tr>
<td style="width: 100%;" colspan="4">
<p>&nbsp;</p>
<p><span style="color: #7e8c8d;"><span style="font-size: 12pt;"><strong>用户路径：</strong><span style="font-size: 11pt;">首页一一点击"免费领取"进入信息填写页一一点击"立即提交"跳出"感谢参与"一一点击"感谢参与"左上角叉，展现"分享好友"按钮</span></span></span></p>
</td>
</tr>
</tbody>
</table>`,
        },
        {
          title: "创意话题包",
          content: `<p style="text-align: center;"><span style="color: #7e8c8d; font-size: 13pt;">组合特色工具，丰富内容玩法</span></p>
<p style="text-align: center;">&nbsp;</p>
<table style="border-collapse: collapse; width: 100%;" border="0">
<tbody>
<tr class="mtr-flex cyhtb">
<td style="width: 20%; text-align: center;">
<p class="mh42"><span class="mf11" style="font-size: 12pt;"><strong><span style="color: #333;">●&nbsp;</span></strong><span style="color: #333;"><strong>热搜词入口</strong></span></span></p>
<p><strong><span style="color: #7e8c8d;"><img src="http://hr.pangodso.com/web_file/44923c34ce5048a39f4441493309f449.png" alt="" width="150" height="295" /></span></strong></p>
<p><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">高曝光热搜入口</span></p>
</td>
<td style="width: 20%; text-align: center;">
<p class="mh42"><span class="mf11" style="font-size: 12pt;"><strong><span style="color: #333;">●&nbsp;</span></strong><span style="color: #333;"><strong>定制互动话题页</strong></span></span></p>
<p><strong><span style="color: #7e8c8d;"><img src="http://hr.pangodso.com/web_file/f2c56bc6e8584a7aae5d3398122fea34.png" alt="" width="150" height="295" /></span></strong></p>
<p><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">品牌属性定制话题</span></p>
</td>
<td style="width: 20%; text-align: center;">
<p class="mh42"><span class="mf11" style="font-size: 12pt;"><strong><span style="color: #333;">●&nbsp;</span></strong><span style="color: #333;"><strong>发布页话题推荐</strong></span></span></p>
<p><strong><span style="color: #7e8c8d;"><img src="http://hr.pangodso.com/web_file/6872f9cbb4064a9e84fd285ebc52e706.png" alt="" width="150" height="295" /></span></strong></p>
<p><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">强化话题参与引导</span></p>
</td>
<td style="width: 20%; text-align: center;">
<p class="mh42"><span class="mf11" style="font-size: 12pt;"><strong><span style="color: #333;">●&nbsp;</span></strong><span style="color: #333;"><strong>品牌贴纸</strong></span></span></p>
<p><strong><span style="color: #7e8c8d;"><img src="http://hr.pangodso.com/web_file/657439c3b4d34c808ab36259edd33cc5.png" alt="" width="150" height="295" /></span></strong></p>
<p><span class="mf10" style="font-size: 11pt;"><span style="color: #7e8c8d;">品牌形象展示利器</span></span></p>
</td>
<td style="width: 20%; text-align: center;">
<p class="mh42"><span class="mf11" style="font-size: 12pt;"><strong><span style="color: #333;">●&nbsp;</span></strong><span style="color: #333;"><strong>发布页红点</strong></span></span></p>
<p><strong><span style="color: #7e8c8d;"><img src="http://hr.pangodso.com/web_file/dc8d53183ae9460ab5111c1b410c480c.png" alt="" width="150" height="295" /></span></strong></p>
<p><span class="mf10" style="color: #7e8c8d; font-size: 11pt;">强化贴纸使用引导</span></p>
</td>
</tr>
</tbody>
</table>`,
        },
        {
          title: "品牌专区",
          content: `<p style="text-align: center;"><span style="font-size: 13pt; color: #7e8c8d;">位于搜索结果首位，提升品牌推广效能</span></p>
<p style="text-align: center;">&nbsp;</p>
<table style="border-collapse: collapse; width: 100%; height: 415.657px;" border="0">
<tbody>
<tr style="height: 21.2188px;">
<td style="width: 23.824%; text-align: center; height: 21.2188px;"><strong><span style="font-size: 13pt; color: #333;">位置优势</span></strong></td>
<td style="width: 16.4901%; height: 415.657px;" rowspan="3">
<p class="mw45" style="text-align: center;"><strong><span class="mf10" style="font-size: 12pt; color: #7e8c8d;">一跳即达</span></strong></p>
<p><img style="display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/ae71c6bc44dc4721855225e4fc68065f.png" alt="" width="100" height="33" /></p>
<p class="mh" style="text-align: center; margin: 0px;"><span style="font-size: 9pt; color: #7e8c8d;display: block;">点击tab直达各个落地页，</span><span style="font-size: 8pt; color: #7e8c8d;">转化路径短</span></p>
<p style="text-align: start; margin: 0px;">&nbsp;</p>
</td>
<td style="width: 59.6859%; height: 21.2188px; text-align: center;" colspan="4"><span style="font-size: 13pt;"><strong><span style="color: #333;">多页面聚合</span></strong></span></td>
</tr>
<tr style="height: 197.219px;">
<td style="width: 23.824%; text-align: center; height: 394.438px;" rowspan="2">
<p><img src="http://hr.pangodso.com/web_file/ec82c477b39d4abb8f7f5cb538e032aa.png" alt="" width="180" height="364" /></p>
<p style="text-align: center; margin: 0px;"><span class="mf9" style="color: #7e8c8d; font-size: 11pt;">首屏黄金位置减少搜索流失，</span></p>
<p style="text-align: center; margin: 0px;"><span class="mf9" style="color: #7e8c8d; font-size: 11pt;">树立品牌形象</span></p>
</td>
<td style="width: 14.9215%; height: 197.219px; text-align: center;">
<p><span style="font-size: 11pt; color: #7e8c8d;">定制H5</span></p>
<p><img src="http://hr.pangodso.com/web_file/46396e0d8ad942478c8ea5efc8aa9984.png" alt="" width="100" height="200" /></p>
</td>
<td style="width: 14.9215%; height: 197.219px; text-align: center;">
<p><span style="font-size: 11pt; color: #7e8c8d;">话题页</span></p>
<p><img src="http://hr.pangodso.com/web_file/1de4367287b84c80aa3b9336f66be5cc.png" alt="" width="100" height="200" /></p>
</td>
<td style="width: 14.9215%; height: 197.219px; text-align: center;">
<p><span style="font-size: 11pt; color: #7e8c8d;">商详页</span></p>
<p><img src="http://hr.pangodso.com/web_file/787dc246a29a40f291d22fc9d354e767.png" alt="" width="100" height="200" /></p>
</td>
<td style="width: 14.9215%; height: 197.219px; text-align: center;">
<p><span style="font-size: 11pt; color: #7e8c8d;">场次页</span></p>
<p><img src="http://hr.pangodso.com/web_file/c3c9e4890d614f3881db6544226e40fc.png" alt="" width="100" height="200" /></p>
</td>
</tr>
<tr class="mh82" style="height: 197.219px;">
<td class="mh82" style="width: 59.6859%; height: 197.219px; text-align: center; vertical-align: top;" colspan="4"><span class="mf11" style="color: #7e8c8d; font-size: 12pt;">整合传播品牌形象，加强用户心智，引导用户互动与消费转化</span></td>
</tr>
</tbody>
</table>`,
        },
        {
          title: "快闪店",
          content: `<p style="text-align: center;"><span style="font-size: 13pt; color: #7e8c8d;">品牌推广新阵地，定制化聚合展示空间</span></p>
<table class="mbt" style="border-collapse: collapse; width: 100%;" border="0">
<tbody>
<tr>
<td style="text-align: center; vertical-align: middle; width: 20%;" rowspan="2">
<p style="text-align: start; "><span style="font-size: 10pt;"><strong><span style="color: #7e8c8d;">&nbsp;</span></strong></span></p>
<p style="text-align: start; "><span style="font-size: 11pt;"><strong><span style="color: #333;">高效曝光</span></strong></span></p>
<p style="text-align: start; "><span style="color: #7e8c8d; font-size: 11pt;">●流量聚焦，高曝光强调品牌认知</span></p>
<p style="text-align: start; "><span style="color: #7e8c8d; font-size: 11pt;"><span style="text-align: center;">●</span>适用商品∶旗舰单品/限时系列/限量联名等</span></p>
</td>
<td style="text-align: center; width: 45.6018%;" rowspan="2">
<p style=""><span style="font-size: 10pt;">&nbsp;</span></p>
<p style=""><span style="font-size: 10pt;"><img src="http://hr.pangodso.com/web_file/0d1329ecef46459a82f158d5afb74a92.png" alt="" width="280" height="456" /><strong><span style="color: #7e8c8d;"><br /></span></strong></span></p>
</td>
<td style="width: 15.8917%;">
<p style=""><span style="font-size: 11pt;"><strong><span style="color: #333;">快速造势</span></strong></span></p>
<p style="line-height: 1.5; text-align: left;"><span style="color: #7e8c8d; font-size: 11pt;">●配合品牌限时活动，提升话题性</span></p>
<p style="line-height: 1.5; text-align: left;"><span style="color: #7e8c8d; font-size: 11pt;">●适用场景∶新品首发/节日活动/限时优惠/限量抢购等</span></p>
</td>
</tr>
<tr>
<td style="width: 15.8917%;">
<p style=""><span style="font-size: 11pt;"><strong><span style="color: #333;">资产沉淀</span></strong></span></p>
<p style="line-height: 1.5; text-align: left;"><span style="color: #7e8c8d; font-size: 11pt;">●品牌号有力的推广工具</span></p>
<p style="line-height: 1.5; text-align: left;"><span style="color: #7e8c8d; font-size: 11pt;">●关注快闪店同时关注品牌号，品牌资产长期沉淀</span></p>
</td>
</tr>
<tr class="mha" style="height: 139.352px;">
<td style="text-align: center; vertical-align: middle; width: 20%; height: 677.611px;" rowspan="1">
<p style="text-align: start; "><span style="font-size: 10pt;"><strong><span style="color: #7e8c8d;">&nbsp;</span></strong></span></p>
<p style="text-align: start; "><span style="font-size: 10pt;"><strong><span style="color: #7e8c8d;">&nbsp;</span></strong></span></p>
<p style="text-align: start; "><span style="font-size: 10pt;"><img style="font-size: medium; text-align: center; display: block; margin-left: auto; margin-right: auto;" src="http://hr.pangodso.com/web_file/dd88fbc358fe40b0a8bdafe351fc9866.png" alt="" width="200" height="575" /><strong><span style="color: #7e8c8d;"><br /></span></strong></span></p>
<p style="text-align: center; "><span style="font-size: 10pt;"><strong><span style="color: #7e8c8d;">&nbsp;</span></strong></span></p>
</td>
<td style="text-align: center; height: 139.352px; width: 63.4935%;" colspan="2">
<p style=""><span style="font-size: 11pt;"><strong><span style="color: #333;">店铺名称区</span></strong></span></p>
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">●顶部展示，强化认知</span></p>
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">●一键同步关注品牌号</span></p>
<hr class="mh" /></td>
</tr>
<tr class="mh135" style="height: 250.477px;">
<td style="text-align: center; height: 250.477px; width: 63.4935%;" colspan="2">
<p style=""><span style="font-size: 11pt;"><strong><span style="color: #333;">店铺头图区</span></strong></span></p>
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">●快闪店主题视觉</span></p>
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">●营业时间贴纸强调限时紧迫感</span></p>
<hr class="mh" /></td>
</tr>
<tr class="mh99" style="height: 159.391px;">
<td style="text-align: center; height: 159.391px; width: 63.4935%;" colspan="2">
<p style=""><span style="font-size: 11pt;"><strong><span style="color: #333;">商品展示区</span></strong></span></p>
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">●品牌广告大图，旗舰商品展示</span></p>
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">●根据品牌需求，自定义配置模块</span></p>
</td>
</tr>
<tr class="mh" style="height: 128.391px;">
<td style="text-align: center; height: 128.391px; width: 63.4935%;" colspan="2">
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">沉浸式体验，</span></p>
<p style=""><span style="color: #7e8c8d; font-size: 11pt;">手势下滑操作</span></p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>`,
        },
        {
          title: "信息流竞价广告",
          content: `<p style="text-align: center;"><span style="font-size: 13pt; color: #7e8c8d;">籍准定向，灵活投放</span></p>
<table class="mbt" style="border-collapse: collapse; width: 101.971%; height: 410.219px;" border="0">
<tbody>
<tr style="height: 410.219px;">
<td class="mha" style="width: 28.3158%; height: 410.219px;">
<p><strong><span style="font-size: 12pt; color: #333;">投放位置</span></strong></p>
<p style="width: 90%"><span style="font-size: 11pt; color: #7e8c8d;">发现页：双列信息流第6/16/26/36/46等逢6位出</span></p>
<p><strong><span style="font-size: 12pt; color: #333;">推广样式</span></strong></p>
<p><span style="font-size: 11pt; color: #7e8c8d;">原生笔记：需为品牌账号/品牌合作人发布的合规笔记</span></p>
<p><span style="font-size: 11pt; color: #7e8c8d;">笔记二跳：可跳转到场次页/留资收集H5</span></p>
<p><strong><span style="font-size: 12pt; color: #333;">推广时段</span></strong></p>
<p><span style="font-size: 11pt; color: #7e8c8d;">自定义：一周7天内按小时任选（至少1小时）</span></p>
<p><strong><span style="font-size: 12pt; color: #333;">定向投放</span></strong></p>
<p>&nbsp;</p>
</td>
<td style="width: 54.4737%; text-align: center; height: 410.219px;"><img src="http://hr.pangodso.com/web_file/aa1dbd201da54d268f2ff03c4b0619cb.png" alt="" width="380" height="386" /></td>
<td style="width: 19.2105%; height: 410.219px;">
<p style="line-height: 1.5;"><span style="font-size: 11pt; color: #333;">● <strong>更原生的推广环境</strong> </span></p>
<p style="line-height: 1.5;"><span style="font-size: 11pt; color: #7e8c8d;">发现页信息流展示符合 用户浏览习惯</span></p>
<p style="line-height: 1.5;">&nbsp;</p>
<p style="line-height: 1.5;"><span style="font-size: 11pt; color: #7e8c8d;"><span style="color: #333;"><span style="font-size: 14.6667px;">● <strong>更精准的人群触达</strong> </span></span></span></p>
<p style="line-height: 1.5;"><span style="font-size: 11pt; color: #7e8c8d;"><span style="color: #7e8c8d;"><span style="font-size: 14.6667px;">支持定向，根据浏览偏 好推荐感兴趣的内容</span></span></span></p>
<p style="line-height: 1.5;">&nbsp;</p>
<p style="line-height: 1.5;"><span style="font-size: 11pt; color: #7e8c8d;"><span style="color: #333;"><span style="font-size: 14.6667px;">● <strong>更灵活的推广机制</strong> </span></span></span></p>
<p style="line-height: 1.5;"><span style="font-size: 11pt; color: #7e8c8d;"><span style="color: #7e8c8d;"><span style="font-size: 14.6667px;">灵活设置预算，自定义 推广时段</span></span></span></p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>&nbsp;</p>`,
        },
      ],
      activeSub: 0,
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
    handleDesc() {
      if (!this.allData[this.activeType].children)
        return this.allData[this.activeType].content;
      return this.allData[this.activeType].children[this.activeSub].content;
    },
  },
  methods: {
    // 改变一级分类
    changeType(type) {
      this.activeType = type;
    },
    // 改变二级分类
    changeSub(type) {
      this.activeSub = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.box {
  margin-top: 100px;
  padding-bottom: 40px;
}
.title-box {
  text-align: center;

  .title {
    color: #0d0d0d;
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 1px;
  }
  .type {
    color: #6e7685;
    letter-spacing: 6px;
    margin-top: 30px;
  }
}
.description {
  width: 910px;
  font-size: 15px;
  margin: 40px auto 0;
  letter-spacing: 2px;
  line-height: 30px;

  br {
    display: none;
  }
}
.float {
  width: fit-content;
  position: relative;
  margin: 50px auto 0;

  .center {
    width: 600px;
  }
  .out {
    position: absolute;
    display: flex;
    align-items: flex-start;

    .icon {
      width: 73px;
    }
    .text {
      margin-left: 15px;
      margin-top: 10px;

      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        margin-top: 5px;
        color: #6e7685;
        line-height: 25px;
        letter-spacing: 2px;
      }
    }
  }
}
.box2 {
  background-color: #f5f7fa;
  padding: 80px 0 100px;

  .content {
    width: 1200px;
    margin: 90px auto 0;
    // display: flex;

    .types {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;

      .type {
        width: 250px;
        height: 60px;
        border: 1px solid #e0e0e0;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        line-height: 60px;
        cursor: pointer;
        position: relative;

        &:hover {
          color: $theme;

          &::after {
            display: block;
          }
        }

        &::after {
          content: "";
          display: none;
          width: 0;
          height: 0;
          border-width: 8px;
          border-style: solid;
          border-color: #5f84de transparent transparent transparent;
          position: absolute;
          left: 50%;
          bottom: -30px;
          transform: translateX(-50%);
        }
        & + .type {
          margin-left: 10px;
        }
      }
      .active {
        color: $theme;
        background-color: #eaecee;
        box-shadow: 0 16px 16px rgba($color: $theme, $alpha: 0.11);

        &::after {
          display: block;
        }
      }
    }

    .subs {
      display: flex;
      justify-content: center;

      .sub {
        font-size: 18px;
        padding: 10px 30px;
        border-bottom: 2px solid #e0e0e0;
        position: relative;
        cursor: pointer;
        transition: 0.5s;

        & + .sub {
          margin-left: 20px;
        }
      }
      .active {
        color: $theme;
        box-shadow: 0 10px 10px -5px rgba($color: #000000, $alpha: 0.2);
      }
    }

    .desc {
      margin-top: 60px;

      .desc_content {
        width: 1000px;
        margin: 0 auto;
        // line-height: 30px;

        ::v-deep {
          p {
            margin: 10px 0;
          }
          img,
          video {
            max-width: 100%;
            height: auto !important;
          }
        }
      }
    }
  }
}

.mm {
  .box {
    margin-top: 60px;
  }
  .title-box {
    .title {
      font-size: 22px;
    }
    .type {
      padding: 0 10px;
      font-size: 15px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
  }
  .description {
    width: 100%;
    padding: 0 10px;
    line-height: 1.5;
    box-sizing: border-box;
    font-size: 14px;
    text-align: justify;
    letter-spacing: 1px;

    br {
      display: block;
    }
  }
  .float {
    width: 100%;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .center {
      width: 80%;
    }
    .out {
      width: 50%;
      margin-bottom: 10px;
      position: static;
      flex-direction: column;
      align-items: center;

      .icon {
        width: 50px;
      }
      .text {
        margin-left: 0;

        .title {
          font-size: 16px;
        }
        .desc {
          font-size: 12px;
          line-height: 1.5;
        }
      }
    }
  }
  .box2 {
    padding-bottom: 40px;

    .content {
      width: 100%;
      margin-top: 40px;
      flex-direction: column;

      .types {
        display: flex;
        overflow: auto;
        justify-content: flex-start;
        padding-bottom: 10px;

        .type {
          width: fit-content;
          height: 50px;
          line-height: 50px;
          flex-shrink: 0;
          padding: 0 20px;
          font-size: 18px;
        }
        .active {
          box-shadow: none;

          &::after {
            display: none;
          }
        }
      }
      .subs {
        overflow: auto;
        justify-content: flex-start;
        padding-bottom: 10px;

        .sub {
          flex-shrink: 0;
        }
      }
      .desc {
        margin-left: 0;
        margin-top: 60px;

        .desc_content {
          font-size: 14px;
          padding: 0 10px;
          box-sizing: border-box;

          ::v-deep {
            .mf9 {
              font-size: 9pt !important;
            }
            .mf10 {
              font-size: 10pt !important;
            }
            .mf11 {
              font-size: 11pt !important;
            }
            .mh {
              display: none !important;
            }
            .mbt,
            .mbt tbody,
            .mbt tr,
            .mbt td {
              display: block;
              width: 100% !important;
            }
            .mha {
              height: unset !important;
            }
            .mw31 {
              width: 31.65% !important;
            }
            .mh42 {
              height: 42px;
            }
            .mspecial {
              font-size: 11pt !important;
              height: 30px;
              display: block;
            }
            .mflex {
              display: flex;
            }
            .mtr-flex {
              display: flex;
              flex-wrap: wrap;

              td {
                width: 46vw !important;
                margin-bottom: 10px;

                &:nth-child(2n) {
                  margin-left: 10px;
                }
              }
            }
            .mtr-flex.cyhtb {
              td {
                width: 31vw !important;

                &:nth-child(4),
                &:nth-child(5) {
                  width: 47vw !important;
                }
                &:nth-child(2n) {
                  margin-left: 0;
                }
              }
            }
            .mh99 {
              height: 99px !important;
            }
            .mh135 {
              height: 135px !important;
            }
            .mw45 {
              width: 39px;
              margin-left: 7px;
            }
            .marginb80 {
              margin-bottom: 80px !important;
            }
            .pa {
              width: 100% !important;
              position: absolute;
              left: 0;
            }
            .pa1 {
              top: 290px;
            }
            .pa2 {
              top: 650px;
            }
            .pa3 {
              top: 1010px;
            }
            .mh82 {
              height: 82px !important;
            }
            .mh329 {
              width: auto;
              height: 329px !important;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .float .center {
    width: 500px;
  }
  .float .out .text .desc {
    font-size: 14px;
  }
  .description {
    width: 1000px;
  }
  .box2 .content {
    width: 1000px;

    .types .type {
      width: 200px;
      font-size: 16px;
    }
    .subs .sub {
      font-size: 15px;
    }
    .desc .desc_content {
      width: 100%;
    }
  }
}
</style>
